/* Oplayce — bouton clair/sombre de l'en-tête : bascule l'attribut data-theme et mémorise le choix. */
(function () {
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-op-theme-toggle]');
    if (!btn) return;
    var current = document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light';
    var next = current === 'dark' ? 'light' : 'dark';
    document.documentElement.dataset.theme = next;
    try {
      localStorage.setItem('op-theme', next);
    } catch (e) {}
  });
})();
